import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportTemplateSelector'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import ReportTemplateSelectorContent from './content'
import LoadingIndicator from '@/components/LoadingIndicator'
import { Label } from 'reactstrap'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'

class ReportTemplateSelector extends React.Component {
  componentDidMount () {
    this.props.getSelectorData(this.props.outputTemplates ? 1 : 0)
  }
  openEditDialog = () => {
    this.props.openDialog({
      dialogType: dialogTypes.reportTemplateSelector,
      onAction: selectedTemplates => this.props.onChange(selectedTemplates),
      items: this.props.reportTemplateSelector.items,
      selectedTemplates: this.props.selectedTemplates
    })
  }
  renderContent () {
    const { reportTemplateSelector, selectedTemplates } = this.props
    if (reportTemplateSelector.fetching) { return <LoadingIndicator /> }
    return (
      <ReportTemplateSelectorContent
        key={reportTemplateSelector.componentKey}
        items={reportTemplateSelector.items}
        selectedTemplates={selectedTemplates}
        readonly
      />
    )
  }
  render () {
    return (
      <div className='ReportTemplateSelector'>
        <Label><Resx name='Reporting.ReportingTemplates' /></Label> <Button size='sm' color='primary' icon='pencil' onClick={this.openEditDialog} disabled={this.props.disabled}><Resx name='Common.Edit' /></Button>
        <div className='mt-3'>
          {this.renderContent()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportTemplateSelector: state.reportTemplateSelector,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getSelectorData: actionCreators.getSelectorData,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportTemplateSelector)



// WEBPACK FOOTER //
// ./src/components/reporting/reportTemplateSelector/index.js